<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 
<vue-snotify/>


<div id="myModalContact" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box has-background-grey">
        <Contact 
        :data_students="data_contact"
        :student_cnt="data_contact.length"
        @emit_close_modal="close_contact_modal"
        >   </Contact>
    </div>
  </div>
</div>



<!-- HEADER  -->
<div class="columns is-vcentered is-gapless is-mobile has-background-grey-dark" style="">
    <div class="column is-1">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-right"></i></span>     
        </button> 
    </div>


    <div class="column is-10 has-text-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold is-size-5">
        Dossiers des étudiants &nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div class="column is-1">
        <button @click="student_add_click()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
</div>
<!-- END HEADER !! -->


<!-- NEW STUDENT  -->
<div v-if="active_view == 'NEW'" class="columns is-centered box has-background-grey-dark" style="margin-top:-2em;">
<div class="column is-8"> 
<div class="columns is-multiline box" style="margin-bottom:10em;">

<div class="column is-12 is-size-4 has-text-weight-bold has-background-white has-text-centered">
     <span class="icon is-small has-text-left"><i class="fas fa-user-plus"></i></span>   &nbsp;&nbsp;&nbsp;&nbsp;  NOUVEL ÉTUDIANT</div>

<div class="column is-12">
<div class="columns is-gapless is-vcentered is-multiline has-background-light" style="">

    <div class="column is-4">
    <div class="columns is-gapless is-mobile is-multiline">
        <div class="column is-12 isLabel">NOM *</div>
        <div class="column is-12"><p class="control has-icons-left"><input id="nom" required v-model="new_nom" class="input is-uppercase is-size-5 is-fullwidth has-text-weight-bold" type="text" placeholder="...."><span class="icon is-small is-left"><i class="fas fa-user" aria-hidden="true"></i></span></p></div>
    </div>
    </div>

    <div class="column is-4">
    <div class="columns is-gapless is-mobile is-multiline">
        <div class="column is-12 isLabel">PRE</div>
        <div class="column is-12"><p class="control has-icons-left"><input  v-model="new_pre" class="input is-uppercase is-size-5 is-fullwidth has-text-weight-bold" type="text" placeholder="...."><span class="icon is-small is-left"><i class="fas fa-user" aria-hidden="true"></i></span></p></div>
    </div>
    </div>


    <div class="column is-2 isLabel">
    <div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">LANG</div>
    <div class="column is-12">
        <div class="select is-size-5 is-fullwidth has-text-weight-bold">
            <select v-model="new_lang" class="has-text-weight-bold has-text-danger">
                    <option value="FR">FR</option>
                    <option value="AN">AN</option>
            </select>
        </div>                
    </div> 
    </div>
    </div>

    <div class="column is-2 isLabel">
    <div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">SEXE</div>
    <div class="column is-12">
        <div class="select is-size-5 is-fullwidth has-text-weight-bold">
            <select v-model="new_sexe" class="has-text-weight-bold has-text-danger">
                    <option value="F">F</option>
                    <option value="M">M</option>
                    <option value="A">A</option>
            </select>
        </div>                
    </div> 
    </div>
    </div>


</div>


<div class="columns box has-background-light is-mobile is-multiline">

<div class="column is-10">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">ADDRESS</div>
    <div class="column is-12">
        <vue-google-autocomplete
            ref="Address"
            id="map"
            classname="input is-fullwidth has-text-weight-bold"
            placeholder="address"
            v-on:placechanged="getAddressData">
        </vue-google-autocomplete>
    </div>
</div>
</div>

<div class="column is-2">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">APT.</div>
    <div class="column is-12">
        <input  v-model="new_apt" class="input is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Apt. ">
    </div>
</div>
</div>

<div class="column is-3">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">TEL CELL.</div>
    <div class="column is-12">
        <input v-mask="'(###) ###-####'" v-model="new_cell" class="input is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Cellulaire ">
    </div>
</div>
</div>
<div class="column is-3">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">TEL AUTRE.</div>
    <div class="column is-12">
        <input v-mask="'(###) ###-####'" v-model="new_tel" class="input is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Autre ">
    </div>
</div>
</div>

<div class="column is-6">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">EMAIL</div>
    <div class="column is-12">
        <input v-model="new_email" class="input is-fullwidth has-text-weight-semibold" placeholder="Email ">
    </div>
</div>
</div>

</div>


<div class="columns box is-mobile is-multiline has-background-warning">
<div class="column is-6">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-6 isLabel">Program *</div>
    <div class="column is-12">
        <div class="select is-info is-fullwidth has-text-weight-bold">
            <select required id="program" class="has-text-weight-bold has-text-danger" v-model="new_progID">
                    <option v-for="(choice,index) in data_programs" :key="index" :value="choice.prog_ID">{{ choice.prog_TITRE_F }} : {{choice.prog_CODEPLUS}}</option>
            </select>
        </div>                
    </div>
</div></div>



<div class="column is-3">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">CODE PERMANENT</div>
    <div class="column is-12"><p class="control has-icons-left"><input  v-mask="'AAAA########'"  v-model="new_perm" class="input is-fullwidth has-text-weight-bold" type="text" placeholder="...."><span class="icon is-small is-left"><i class="fas fa-user" aria-hidden="true"></i></span></p></div>
</div>
</div>

<div class="column is-3">
<div class="columns is-gapless is-mobile is-multiline">
    <div class="column is-12 isLabel">GROUPE CODE</div>
    <div class="column is-12"><p class="control has-icons-left"><input  v-model="new_code" class="input is-fullwidth has-text-weight-bold" type="text" placeholder="...."><span class="icon is-small is-left"><i class="fas fa-user" aria-hidden="true"></i></span></p></div>
</div>
</div>


</div>
<!-- END PROGRAM - PERM - GRP ROW  -->





<div class="columns is-gapless is-mobile is-multiline">



<div class="column  has-text-centered is-size-4 has-text-weight-bold is-2"><a @click="student_add_click()" class="button is-fullwidth has-background-danger=light has-text-danger"><span class="icon is-medium"><i class="fas fa-user-slash"></i></span></a></div>
<div class="column is-6"></div>
<div class="column  has-text-centered is-size-4 has-text-weight-bold is-4"><a @click="student_insert()" class="button is-fullwidth has-background-success-light has-text-success"><span class="icon is-medium"><i class="fas fa-save"></i></span></a></div>

</div></div>

</div></div></div>
<!-- END NEW STUDENT  -->


<div id="mySidebar" class="sidebar" style="margin-top:3.7em;margin-bottom:4em;">
<div class="box is-radiusless has-background-grey-dark" style="margin-bottom:.4em;"> 
<div class="columns is-vcentered is-multiline is-gapless">

<div class="column is-10 is-size-6 has-text-grey-lighter">
    Rechercher des étudiants
</div>

<div class="column is-2">
    <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
    </button> 
</div>

<div class="column is-12 control has-icons-left">
    <input  v-model="search" @keyup.enter="students_search()" class="input is-fullwidth has-text-weight-bold" type="text" placeholder="search">
    <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span>
</div>

<div class="column  has-text-centered is-size-4 has-text-weight-bold is-6"><a @click="students_search()" class="button is-fullwidth has-background-grey-dark has-text-success"><span class="icon is-medium"><i class="fas fa-search"></i></span></a></div>
<div class="column  has-text-centered is-size-4 has-text-weight-bold is-3"><a @click="search_clear()" class="button is-fullwidth has-background-grey-dark has-text-danger"><span class="icon is-medium"><i class="fas fa-user-slash"></i></span></a></div>
<div class="column  has-text-centered is-size-4 has-text-weight-bold has-text-white is-3"> <span class="is-size-7">Cnt.</span>{{this.students.length}}</div>
</div>
</div>  <!-- end box -->

<!-- MENU  !!!!  :style="return_style_info(info.maxDt,info.student_blnComplete, info.student_blnActive)" -->
    <div @click="student_load(index)" class="columns is-vcentered box is-paddingless is-gapless is-mobile is-multiline isLink" :class="return_style_clicked(index)"  v-for ="(info, index) in students" :key="index"
    style="background-color: CORNSILK;border: 1px solid TAN;margin-top:-1.6em;margin-bottom:2em;">              
            <div class="column is-2">          
             <!-- <figure class="image is-48x48 is-pulled-right"> 
                <img :src="return_pic_menu(info.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
             </figure>        -->
            </div>
            <div class="column is-10">   
                <div class="columns is-multiline is-gapless">      
                    <div class="column is-9 is-size-6 has-text-weight-bold">{{info.student_lNAME}}</div>
                    <div class="column is-3 is-size-7 has-text-weight-bold has-text-right">{{check_solde(info.student_frais_solde)}}&nbsp;&nbsp;</div>
                    <div class="column is-8 is-size-7" style="margin-top:-.5em;"> {{info.student_fNAME}}</div>
                    <div class="column is-4 is-size-7 has-text-weight-bold has-text-info has-text-right" style="margin-top:-.5em;"> {{info.student_GRPCODE}}&nbsp;&nbsp;</div>
                </div>
            </div>               
    </div>

</div>
<!-- END SIDEBAR  -->



<!--</div>   end menu-->
<!-- ************************************************  -->

<div id="mainContent" >



<div v-if="active_view == 'DETAILS'" class="columns is-multiline is-gapless has-background-black" style="margin-top:-1.6em;"> <!-- MAIN COLUMNS   :: {{stud_code}} :: {{stud_prog}} -->
<div class="column is-5 is-size-5 has-text-white mt-2 is-uppercase has-text-weight-bold" style=""> &nbsp;&nbsp;{{stud_last}}, {{stud_first}}</div>

<div class="column is-2 has-text-light has-text-right mt-3">{{check_solde(this.stud_solde)}}</div>

<div class="column is-5">
<div class="columns is-gapless is-pulled-right">


    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="student_menu_click('DETAILS')" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-info-circle"></i></span><span>DÉT</span>
        </a>
    </div>

    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="student_menu_click('TRANINFO')" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-info-circle"></i></span><span>INFO</span>
        </a>
    </div>

    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="student_menu_click('COURSES')" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-graduation-cap"></i></span><span>COUR</span>
        </a>
    </div>

    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="student_menu_click('SCHEDULE')" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-info-circle"></i></span><span>SCHED</span>
        </a>
    </div>


    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="student_menu_click('PAIMENTS')"  class="button is-dark  is-fullwidth"><span class="icon"><i class="fab fa-github"></i></span><span>PAI</span>
        </a>
    </div> 

    <div class="column colBorder is-2 has-text-weight-bold">
        <a @click="contact_click()"  class="button is-dark  is-fullwidth"><span class="icon"><i class="fas fa-comment-alt"></i></span><span>CON</span>
        </a>
    </div> 

</div></div>





<div class="column is-12 has-background-white"> <!-- begin data-->




<!-- STUDENT DETAILS !!!! -->
<div v-if="active_detail == 'DETAILS'" class="" style="">
    <CompDetails ref="compDetails" 
    :studentID="stud_id" enabled="true" 
    @emit_data_update="emit_data_update"
    @emit_photo_change="emit_photo_change"
    @emit_student_deleted="emit_student_deleted"
    :key="stud_id"
    @emit_somethingChanged="emit_somethingChanged"
    @emit_somethingSaved="emit_somethingSaved"></CompDetails>
</div>


<div v-if="active_detail == 'TRANINFO'">
<CompTranInfo :studentID="stud_id" :programs="data_programs" :key="stud_id"
@emit_somethingChanged="emit_somethingChanged"
@emit_somethingSaved="emit_somethingSaved"></CompTranInfo>
</div> 
<!-- END SHOW STUDENT DETAILS -->

<!-- STUDENT COURSES !!!! -->
<div v-if="active_detail == 'COURSES'" style="margin-top:.5em;margin-bottom:4em;">
    <CoursesStudent :studentID="stud_id" :key="stud_id" ></CoursesStudent> 
</div>
<!-- END STUDENT COURSES !!!! -->



<!-- STUDENT SCHEDULE !!!! -->
<div v-if="active_detail == 'SCHEDULE'" style="margin-top:1em;">
    <CompGroupSchedule 
        :key="randomKey()"
        type="student"
        :input_id="stud_id"
        :dat_start="stud_dtStart" ></CompGroupSchedule>
</div>
<!-- END STUDENT COURSES !!!! -->





<!-- STUDENT PAIMENTS !!!!padding-left:1.5em;padding-right:1.5em; -->
<div v-if="active_detail == 'PAIMENTS'" style="">
<div class="columns is-centered box has-background-grey-light">
<div class="column is-10">
    <PaymentsStudent @emit_fee_change="emit_fee_change" :studentID="stud_id" showHeader="false" :key="stud_id" ></PaymentsStudent> 
</div></div>



    
</div>
<!-- END STUDENT COURSES !!!! -->


</div>
</div>
<!-- END DETAIL VIEW !!!!  -->


<!-- STUDENT BOXES -->
<div  v-if="active_view == 'SEARCH'" class="columns is-multiline">
<div class="column is-3" style="" v-for ="(info, index) in students" :key="index" :class="return_style_selected(index)">
<div class="box is-shadowless has-background-grey" style="border: 2px solid LIGHTGRAY;padding:5px;margin-bottom:0em;"> 
<div @click="student_load(index)" class="columns is-multiline is-mobile isLink is-gapless" >
   

<div class="column is-3">
   <!-- <figure class="image is-64x64"> <img :src="return_pic_box(info.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="...."></figure> -->
</div>
<div class="column is-9">
<div class="columns is-multiline is-mobile is-gapless has-text-white">

    <div class="column is-12 is-uppercase has-text-weight-bold is-size-5" style="">{{info.student_lNAME}}</div>
    <div class="column is-12 is-uppercase is-size-6" style="margin-top:-.5em;">{{info.student_fNAME}}</div>

    <div class="column is-12 is-uppercase has-text-info has-text-weight-bold is-size-5 is-size-6 has-text-right" style="margin-top:-.5em;">{{info.student_GRPCODE}}</div>






<!-- 
<div class="column is-3"> 
    <span v-if="info.student_blnComplete" class="icon is-pulled-right" style="color:darkgreen;"><i class="fas fa-user-graduate fa-lg"></i></span> 
    <span v-if="!info.student_blnActive" class="icon is-pulled-right" style="color:darkred;"><i class="fas fa-window-close"></i></span> 
</div> -->



<!-- </div> -->
</div>
</div>
</div>
</div>
</div>
<!-- END STUDENT BOXES -->

</div> <!-- end content-->




</div> <!-- end main column-->




</div>
</template>


 
<script>
import axios from 'axios';
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import moment from 'moment';
import myUtilities from "@/assets/js/utilities.js";

import CompGroupSchedule from "@/components/Comp_Group_Schedule";

import CoursesStudent  from '@/components/Comp_Student_Courses';
import PaymentsStudent  from '@/components/Comp_Student_Pay_II'; // Payments';
import CompDetails from "@/components/Comp_Student_Details"

import CompTranInfo from "@/components/Comp_Student_TranInfo"

import Contact from '@/components/Comp_Contact'

export default {
        
        components: {Contact , VueGoogleAutocomplete,  CoursesStudent, CompDetails, PaymentsStudent, CompTranInfo , CompGroupSchedule },

        data() {
            return {
                activeMenu:-1,
                 students:'',
active_view:'SEARCH', // WHAT SCREEN DETAILS,NOTES ....
active_detail:'',

isDirty:false, // EMITTED TO CHECK IF DIRTY

                 search:'',
                 isLoading:false,
                 navOpen:false,

//noPic:'https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage'



new_show:false, // NEW STUDENT
new_nom:'',
new_pre:'',
new_perm:'',
new_code:'',
new_cell:'',
new_tel:'',
new_email:'',
new_apt:'',
new_progID:'',
new_lang:'',
new_sexe:'',

new_id:'',

//AUTOCOMPLETE
    address: '',
    place: '',


show_header:false,



show_schedule:false,
show_search_boxes:false, 

dt_sched_start:'',
dt_sched_end:'',
data_schedule_data:[],

data_programs:[],

calEvents : [],

stud_id:'',
stud_last:'',
stud_first:'',
stud_perm:'',
stud_code:'',
stud_prog:'',
stud_photo:'',
stud_solde:0,
stud_dtStart:'',

student_mod:false,

imageData: '', // this.return_pic(),

data_contact:[],

            config: { // FLATPICKER
                altFormat: "M j, Y",
                altInput: true
            },
            dtToday:moment().format('YYYY-MM-DD'),



            }
        },


beforeRouteLeave:function (to, from, next) {
    if (this.isDirty) {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; next()}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; next(false)  }},
        ]  });
    } else (next())
},
 



mounted() {


    // GET PROGRAMS
    var sql = "SELECT * FROM MyMEQ_PROGRAM WHERE prog_ACTIVE = 1 ORDER BY prog_TITRE_F"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_programs = res.data           
        if (sessionStorage.getItem('search_text')) {
            //
                this.search = sessionStorage.getItem('search_text')
                this.students = JSON.parse(sessionStorage.getItem('search_data'))
                // this.show_search_boxes=true; 
                // this.show_header = false
                // this.active_view = ''               
        } else {
// LOAD SOME DATA BY DEFAULT !
            var query =  `SELECT  TOP (10) MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
            MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath,
            student_apt,student_Address, MyMEQ_STUDENT.student_City, MyMEQ_STUDENT.student_Province, MyMEQ_STUDENT.student_Postal,  MyMEQ_STUDENT.student_NumAdmission, MyMEQ_STUDENT.student_Birthday, MyMEQ_PROGRAM.prog_CODE, MyMEQ_PROGRAM.prog_CODEPLUS, MyMEQ_PROGRAM.prog_TITRE_F, MyMEQ_PROGRAM.prog_TITRE_E , MyMEQ_STUDENT.student_frais_solde
            , student_CreateDate FROM MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID         
            ORDER BY student_ID DESC, student_lNAME,student_fNAME`;
            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => {
                this.students = res.data
                // sessionStorage.setItem('search_text', this.search)
                // sessionStorage.setItem('search_data', JSON.stringify(this.students))
                
                this.active_view='SEARCH', // WHAT SCREEN DETAILS,NOTES ....
                this.active_detail=''
            });

        }    



        setTimeout(() => { this.openNav(); }, 500);
        this.isLoading=false;
    });


},


methods: {

contact_click:function(key) {
    var query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_eMail, MyMEQ_STUDENT.student_TelHome
    , 1 AS goodToGo FROM MyMEQ_STUDENT 
    WHERE (student_ID = '` + this.stud_id + `') ORDER BY student_lNAME`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_contact = res.data
        document.querySelector('#myModalContact').classList.add('is-active');
    });

},
// END CONTACT CLICK ----
close_contact_modal:function(isSent) {
    document.querySelector('#myModalContact').classList.remove('is-active');
    if (isSent==true) {
        this.$snotify.success(' SENT !!', {
            timeout: 500,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        }); 
    }
},


emit_fee_change:function(solde) {
// FEE CHANGED IN PAYMENT MODULE
    this.students[this.activeMenu].student_frais_solde = solde
    this.stud_solde = solde
},
check_solde:function(solde) {
    if (solde > 0 ) {
         try {return '$' + parseFloat(solde).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
        catch(err) {return ''}   
    } else {
        return ''
    }
}, // END CHECK IFHAS SOLDE




emit_somethingChanged:function() {
    this.isDirty = true;  
},
emit_somethingSaved:function() {
    this.isDirty = false;  
},



toggle_student_mod:function() {
    this.student_mod = !this.student_mod

},

save_student_mod:function() {
    // CALL FUNCTION IN CHILD !!!! (SAVE)
    this.$refs.compDetails.emit_save();
   // this.student_mod = false
},
emit_data_update:function(data) {
 this.stud_last = data.student_lNAME
 this.stud_first  = data.student_fNAME
 this.stud_code  = data.student_GRPCODE

this.students[this.activeMenu].student_lNAME = data.student_lNAME
this.students[this.activeMenu].student_fNAME = data.student_fNAME
this.students[this.activeMenu].student_GRPCODE = data.student_GRPCODE

},

emit_photo_change:function(img) {
this.students[this.activeMenu].student_PhotoPath = img
},



search_clear:function(){
     this.isLoading=true;
    this.students = ''
    this.search = ''
    sessionStorage.removeItem("search_text");
    sessionStorage.removeItem("search_data");
    this.show_header = false
    this.show_search_boxes = true 

    this.activeMenu = -1
    this.isLoading=false; 
},

// check_if_Saved() {
//     if (this.isDirty) {
//     this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
//     position: "centerCenter",
//         buttons: [
//             {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; return true}},
//             {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false }},
//         ]  });
//     } else return true
// },


student_menu_click:function(mnuView){
    // CHECK FOR UNSAVED CHANGES !!!!
    if (this.isDirty) {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.isDirty = false ; this.active_detail = mnuView }},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return }},
        ]  });
    } else { this.active_detail = mnuView }   

}, 

student_load:function(index) {
    // CHECK FOR UNSAVED CHANGES !!!!
    if (this.isDirty) {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.isDirty = false ; this.student_load_DO(index)  }},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return }},
        ]  });
    } else { this.student_load_DO(index) }  
},

student_load_DO:function(index) {

    this.student_mod = false 
    this.active_view = 'DETAILS'
    if (this.active_detail=='') {this.active_detail='DETAILS'}

    this.stud_id= this.students[index].student_ID
    this.stud_last= this.students[index].student_lNAME
    this.stud_first= this.students[index].student_fNAME
    this.stud_perm=  this.students[index].student_CodePerm
    this.stud_code=  this.students[index].student_GRPCODE 
    this.stud_prog=  this.students[index].prog_TITRE_F
    this.stud_photo=  this.students[index].student_PhotoPath 
    this.stud_solde=  this.students[index].student_frais_solde
// FOR CALENDAR
    this.stud_dtStart= moment(this.students[index].student_CreateDate).format('YYYY-MM-DD')


    //this.closeNav()
    this.activeMenu = index
},


emit_student_deleted:function() {
    this.students.splice(this.activeMenu,1)
    this.active_view = 'SEARCH'
},



student_add_click:function() {
    // CHECK FOR UNSAVED CHANGES !!!!
    if (this.isDirty) {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.isDirty = false ; this.student_add_click_DO()  }},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return }},
        ]  });
    } else { this.student_add_click_DO() }  
},

student_add_click_DO:function() {

// IF OPEN -- THENCLOSE
    if (this.active_view == 'NEW') 
        {
        this.active_view = 'SEARCH'
        this.openNav()
        return}
    else {
        this.active_view = 'NEW'
        this.show_header = false
        this.show_search_boxes = false
       
        this.closeNav()

        this.stud_id= 0
        this.new_nom= '';this.new_pre= '';this.new_perm=  '';this.new_code=  ''
        this.new_cell= '';this.new_tel= '';this.new_email=  '';this.new_apt=  ''
        this.new_progID=  '';this.new_lang= 'FR';this.new_sexe= 'F'
        this.new_show=true}

},



chk_string:function(val){
    // CHECK FOR BLANC STRING --
    try {return val.replace(/'/g,"''")}
    catch(err) {return ''}
},


student_insert:function() {
    if (!document.getElementById('nom').validity.valid) {alert('Enter Nom'); return}
    if (!document.getElementById('program').validity.valid) {alert('Enter Programme'); return}

// ADDRESS 
var sqlAddress = ''
if (this.address) {
    sqlAddress += ",student_rueNUM = '" + this.chk_string(this.address.street_number) + "'," 
    sqlAddress += "student_Address = '" + this.chk_string(this.address.route) + "'," 
    sqlAddress += "student_City = '" + this.chk_string(this.address.locality) + "',"
    sqlAddress += "student_Province = '" + this.chk_string(this.address.administrative_area_level_1) + "',"
    sqlAddress += "student_Country = '" + this.chk_string(this.address.country) + "',"
    sqlAddress += "student_Postal = '" + this.chk_string(this.address.postal_code) + "' " 
}

var sql;

sql = "SELECT MAX(student_NumAdmission)+1 as nMax FROM myMEQ_STUDENT"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => {

var numAdmission = res.data[0].nMax




sql = "INSERT INTO MyMEQ_STUDENT(student_NumAdmission, student_lNAME, student_CreateDate, student_EndDate,student_blnActive,student_blnComplete,student_PhotoPath,student_frais_owe,student_frais_pay,student_frais_solde) VALUES (" + numAdmission + ","
sql += "'" + this.new_nom.replace(/'/g,"''") + "',"
sql += "'" + moment().format('YYYY-MM-DD') + "','" + moment().format('YYYY-MM-DD') + "',1,0,'',0,0,0)"
sql += ";SELECT SCOPE_IDENTITY() AS newID;"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => {

this.new_id = res.data[0].newID
    sql = "UPDATE MyMEQ_STUDENT SET "
    sql += "prog_ID = " + this.new_progID + ","
    sql += "student_fNAME = '" + this.chk_string(this.new_pre.toUpperCase()) + "',"
    sql += "student_lNAME = '" + this.chk_string(this.new_nom.toUpperCase()) + "',"
    sql += "student_TelOther = '" + this.chk_string(this.new_cell) + "',"
    sql += "student_TelHome = '" + this.chk_string(this.new_tel) + "',"
    sql += "student_eMail = '" + this.chk_string(this.new_email) + "', "
    sql += "student_CodePerm = '" + this.chk_string(this.new_perm.toUpperCase()) + "', "
    sql += "student_GRPCODE = '" + this.chk_string(this.new_code) + "', "
   // sql += "student_Birthday = " + this.chk_date(this.data_student[0].student_Birthday) + ", "
    sql += "student_apt = '" + this.chk_string(this.new_apt) + "', "
    sql += "student_Sex = '" + this.chk_string(this.new_sexe) + "' "
    sql += sqlAddress
    sql += " WHERE student_ID = " + this.new_id

    // sql += "student_apt = '" + this.chk_string(this.new_lang) + "' "
// INSERT INTO TRANSMISSION
var lang = "FR = Français"
if (this.new_lang == 'AN') {lang='AN = Anglais'}
sql += " ; INSERT INTO  myMEQ_STUDENT_TRANSMISSION (student_ID,matLang,useLang) VALUES (" + this.new_id + ",'" + lang + "','" + lang + "')"

// INSERT LOG -- DOSSIER CREATED
var tm = new Date().toLocaleTimeString();
sql += " ; INSERT INTO MyMEQ_STUDENT_COMMENTS (student_ID ,comment_STAFF, comment_DATE, comment_time, comment_DESC)  VALUES ( "
sql +=  this.new_id + ",'" + sessionStorage.getItem('user_name') +  "','" + moment().format('YYYY-MM-DD') + "','" + tm + "','" + "Dossier Created" + "');" 

 

console.log ('UPDATE ----------')
console.log(sql)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => {

// LOAD THE STUDENT GROUP

       // this.search = this.new_code
       // this.students_search()

this.search = ''
this.stud_last = this.new_nom
this.stud_first = this.new_pre
this.stud_code = this.new_code

this.students = []
this.students.push({student_ID:this.new_id,student_lNAME:this.new_nom ,student_fNAME:this.new_pre ,student_GRPCODE: this.new_code })
this.activeMenu = 0

        this.new_show=false
        this.active_view = 'DETAILS'
        this.active_detail = 'TRANINFO'
        this.show_header = true
        this.show_search_boxes = false

        this.stud_id = this.new_id // RELOAD ??
        this.openNav();


    this.$snotify.success('Saved !!', {
    timeout: 2000,
    showProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true
    });



    });    
    });
    });

},


students_search_TEST:function() {
    var searchSplit = this.search.replace(/'/g,"''")
    searchSplit = searchSplit.split(" ")
    alert(searchSplit.length)

var sWhere = "" ; var i
for (i = 0; i < searchSplit.length  ; i++) {
    sWhere += "((student_GRPCODE LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_lNAME LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_fNAME LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_CodePerm LIKE '" + searchSplit[i] + "%25')) AND " 
}
sWhere = sWhere.substring(1,sWhere.length - 4)
alert (sWhere)

},

students_search:function() {
    // CHECK FOR UNSAVED CHANGES !!!!
    if (this.isDirty) {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.isDirty = false ; this.students_search_DO()  }},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return }},
        ]  });
    } else { this.students_search_DO() }  
},

students_search_DO:function() {

    this.active_view = 'SEARCH'

    this.activeMenu = -1
    if (this.search == '') {return;}

    this.isLoading=true;

    var searchSplit = this.search.replace(/'/g,"''")
    searchSplit = searchSplit.split(" ")
   

var sWhere = "" ; var i
for (i = 0; i < searchSplit.length  ; i++) {
    sWhere += " ((student_GRPCODE LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_lNAME LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_fNAME LIKE '" + searchSplit[i] + "%25') " 
    sWhere += " OR (student_CodePerm LIKE '" + searchSplit[i] + "%25')) AND " 
}
sWhere = sWhere.substring(1,sWhere.length - 4)

    var query =  `SELECT  TOP (100) MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath,
    student_apt,student_Address, MyMEQ_STUDENT.student_City, MyMEQ_STUDENT.student_Province, MyMEQ_STUDENT.student_Postal,  MyMEQ_STUDENT.student_NumAdmission, MyMEQ_STUDENT.student_Birthday, MyMEQ_PROGRAM.prog_CODE, MyMEQ_PROGRAM.prog_CODEPLUS, MyMEQ_PROGRAM.prog_TITRE_F, MyMEQ_PROGRAM.prog_TITRE_E , MyMEQ_STUDENT.student_frais_solde
    , student_CreateDate FROM MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID         
    WHERE  ` + sWhere + `  
    ORDER BY student_lNAME,student_fNAME`;

console.log(query)

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { this.students = res.data
        sessionStorage.setItem('search_text', this.search)
        sessionStorage.setItem('search_data', JSON.stringify(this.students))
        this.isLoading=false;   

    })  
},



// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

 

return_pic_menu:function(pic) {
    console.log('menu pic --'+pic+'')
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},
return_pic_box:function(pic) {
    console.log('boxxer pic --'+pic+'')
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},

return_style_clicked:function(index) {
    if (index == this.activeMenu) {
        return ' has-background-primary'
    } 
},
return_style_info:function(dt, bComplete,bActive) {

/* if (!bActive) { return 'background-color: ' + this.$colourBad + ';border: 1px solid LIGHTGRAY;padding:10px;' }
if (!dt) { return 'background-color: hsla(0,0%,0%,0.1);border: 1px solid LIGHTGRAY;padding:10px;'}
if (bComplete) { return 'background-color: ' + this.$colourGood + ';border: 1px solid LIGHTGRAY;padding:10px;' }
    
var d = dt.substring(0,10)
if (this.dtToday < d) {return 'background-color: ' + this.$colourActive + ';border: 1px solid LIGHTGRAY;padding:10px;'} 
 */
// HERE NOTHING
return 'background-color: white;border: 1px solid LIGHTGRAY;padding:10px;'

},

return_style_selected:function(index) {
    if (index == this.activeMenu) {
        return ' has-background-primary'
    } else {
        return ' has-background-white'
    }
},


sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() { 
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},

    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData) {
        this.address = addressData;
        this.place = placeResultData
    },


}, // END METHODS
} // END EXPORT
</script>

<style>
img {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 100px;
}
</style>